import React, { useRef, useEffect, useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { unselectAll, selectAll } from '~data/actions/bookmarks'

import { HeaderFirstAction as FirstAction, Button } from '~ui'

export default function BookmarksHeaderSelectModeCheckbox({ selectMode = {} }) {
    const dispatch = useDispatch()
    const allCheckbox = useRef(null)
    const { all, ids = [], spaceId } = selectMode

    useEffect(() => {
        if (allCheckbox.current)
            allCheckbox.current.indeterminate = !all && ids.length != 0 ? true : undefined
    }, [all, ids.length])

    const onInputClick = useCallback(() => {
        if (all)
            dispatch(unselectAll(spaceId))
        else
            dispatch(selectAll(spaceId))
    }, [dispatch, all, spaceId])

    return (
        <FirstAction>
            <Button
                variant='active'
                onClick={onInputClick}>
                <label className={'ui-bm-select-check'}>
                    <input
                        ref={allCheckbox}
                        type='checkbox'
                        title={t.s('selectAll')}
                        checked={!!all}
                        readOnly />
                </label>
            </Button>
        </FirstAction>
    )
}
